export const PROGRAM_STATUS = {
  PENDING: "PENDING",
  CONFIRMED: "CONFIRMED",
  SKIPPED: "SKIPPED",
};

export const BATCH_FLOW_STEPS = [
  { label: "Select Program and Batch" },
  { label: "Review & Confirm" },
];

export const BATCH_FLOW_STEP_INDEX = {
  SELECT_PROGRAM: 0,
  REVIEW: 1,
};

export const BATCH_PREFERENCE_STORAGE_PREFIX = "plutus.batchPreference";

export const BATCH_PREFERENCE_ACCESS_PREFIX = "plutus.batchPreference.access";

export const BATCH_PREFERENCE_STORAGE_STATUS = {
  COMPLETED: "completed",
  PAYMENT_ENTERED: "payment_entered",
};

export const WEEKDAY_LABELS = {
  1: "Mon",
  2: "Tue",
  3: "Wed",
  4: "Thu",
  5: "Fri",
  6: "Sat",
  7: "Sun",
};

export const SKIP_REASON_OTHER = "OTHER";

export const SKIP_REASONS = [
  {
    value: "NO_SUITABLE_SCHEDULE",
    label: "No suitable class schedule available",
  },
  {
    value: "PREFERRED_START_DATE_UNAVAILABLE",
    label: "Preferred start date unavailable",
  },
  {
    value: "CONFLICTS_WITH_ANOTHER_PROGRAM",
    label: "Available batches conflict with another Program",
  },
  {
    value: "DECIDE_LATER",
    label: "Parent or student wants to decide later",
  },
  {
    value: "TIMETABLE_NOT_AVAILABLE",
    label: "Student timetable is not available yet",
  },
  {
    value: "SALES_CALL_ENDED",
    label: "Sales call ended before batching was completed",
  },
  {
    value: "TECHNICAL_ISSUE",
    label: "Technical issue prevented batching",
  },
  {
    value: SKIP_REASON_OTHER,
    label: "Other",
  },
];

export const getSkipReasonLabel = (code) => {
  const match = SKIP_REASONS.find((reason) => reason.value === code);
  return match ? match.label : code;
};
